import {Params} from '../getConfig'

export const amplifyKiwiStaging: Params = {
  aws_user_pools_id: 'eu-west-1_LV14PMdwG',
  aws_cognito_identity_pool_id: '', // Not needed for any partner
  aws_user_pools_web_client_id: '3tg7871cre3aasidn9p1b56qlb',
  oauth_domain: 'kiwi-auth-staging.auth.eu-west-1.amazoncognito.com',
  aws_user_files_s3_bucket: '' // Not needed for any partner
}
